import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Table, Tooltip } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Link, useHistory } from "react-router-dom";
import { logDataHelperFunctions } from "../../helpers/logdata-helper";
import { tlogHelper } from "../../helpers/tlog/tlog-helper";
import {
  convertValue,
  reportColumnEnums,
  getDecimalPoint,
  MEASUREMENT_KEYS,
  GlobalUnitEnum,
} from "../../helpers/unit-conversion";
import TlogTab from "../../layout/tlogTab";
import {
  CHECKED_TLOG_DATA,
  POST_EXCLUDED_SAGA,
} from "../../redux/pqrReportData/types";
import TlogTableView from "../TlogData/TlogTableView";

const TlogData = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const {
    stationNumbers,
    station_number,
    buyType,
    type,
    zone,
    weld_number,
    s_deviceid_event,
    weld_time,
    start_time,
    end_time,
    band_diameter,
    logging_distance,
    bug_number,
    lead_wire_diameter,
    trail_wire_diameter,
    pipe_diameter,
    autoIncrement,
    gps,
    iwm,
    tilt_start,
    tilt_end,
    isM500,
    rawZoneView,
    view,
  } = location.state || {};

  const { weld_no, Bugtype, deviceid, weldNumber, bugTypepqr, passn } =
    location.state || {};

  const queryParams = new URLSearchParams(location.search);
  let boundary = queryParams.get("boundary");

  boundary = boundary ? Number(boundary) : null;
  const dispatch = useDispatch();
  const history = useHistory();
  const hasData = weld_no && Bugtype && deviceid;

  const reducer = useSelector((state) => state.tlogsReducer);
  const reducerList = useSelector((state) => state);
  const selectedProject = reducerList?.projectReducer?.selectedProject;
  const { projectReducer } = useSelector((state) => state);

  const selectedProjectId = useSelector(
    (state) => state?.projectReducer?.selectedProject?.project_id
  );
  const selectedProjectName = useSelector(
    (state) => state?.projectReducer?.selectedProject?.project_name
  );

  const globalUnit = useSelector(
    (state) =>
      state.projectReducer?.selectedProject?.globalUnit ||
      GlobalUnitEnum.IMPERIAL
  );

  const [reportColumns, setReportColumns] = useState({});
  useEffect(() => {
    if (projectReducer?.selectedProject?.reportColumns) {
      try {
        let parsedData = JSON.parse(
          projectReducer?.selectedProject?.reportColumns
        );

        setReportColumns(parsedData);
        setColumns([
          {
            title: t("tlogData.bugno"),
            dataIndex: "bugNumber",
            key: "bugNumber",
          },
          {
            title: `${
              selectedProject.weldAssignmentType == "GPS"
                ? t("tlogData.gps")
                : t("tlogData.bandDiameter") +
                  `( ${tlogHelper.returnUnitBasedOnColumns(
                    reportColumnEnums.BandDiameter,
                    parsedData
                  )} )`
            }`,
            dataIndex: "gps",
            key: "gps",
          },
          {
            title:
              t("tlogData.wirediameter") +
              `( ${tlogHelper.returnUnitBasedOnColumns(
                reportColumnEnums.WireDiameter,
                parsedData
              )} )`,
            dataIndex: "wireDiameter",
            key: "wireDiameter",
          },
          {
            title:
              t("tlogData.loggingdistance") +
              `( ${tlogHelper.returnUnitBasedOnColumns(
                reportColumnEnums.LoggingDistance,
                parsedData
              )} )`,
            dataIndex: "loggingDistance",
            key: "loggingDistance",
          },
          {
            title: t("tlogData.pipediameter"),
            dataIndex: "pipeDiameter",
            key: "pipeDiameter",
          },
          {
            title: t("tlogData.autoIncrement"),
            dataIndex: "autoIncrement",
            key: "autoIncrement",
          },
          {
            title: t("tlogData.weldstarttime"),
            dataIndex: "weldStartTime",
            key: "weldStartTime",
          },
          {
            title: t("tlogData.Weldendtime"),
            dataIndex: "weldEndTime",
            key: "weldEndTime",
          },
          {
            title: t("tlogData.weldtime"),
            dataIndex: "weldTime",
            key: "weldTime",
          },
        ]);

        console.log(
          {
            wireDiameter:
              type == "Lead" || station_number == "0"
                ? convertValue(
                    lead_wire_diameter,
                    parsedData?.units?.["Band Diameter"],
                    false,
                    getDecimalPoint(MEASUREMENT_KEYS.WIRE_DIAMETER, globalUnit)
                  )
                : convertValue(
                    trail_wire_diameter,
                    parsedData?.units?.["Wire Diameter"],
                    false,
                    getDecimalPoint(MEASUREMENT_KEYS.WIRE_DIAMETER, globalUnit)
                  ),
            loggingDistance:
              station_number == "0"
                ? JSON.parse(iwm || "{}")?.Logging_period
                : convertValue(
                    logging_distance,
                    parsedData?.units?.["Logging Distance"],
                    false,
                    getDecimalPoint(MEASUREMENT_KEYS.DISTANCE, globalUnit)
                  ),
            pipeDiameter: pipe_diameter,
          },
          "setDataParamssetDataParamssetDataParams"
        );
        setDataParams([
          {
            ...data?.[0],
            gps:
              selectedProject.weldAssignmentType == "GPS"
                ? JSON.parse(gps ?? "{}")?.Latitude +
                  ", " +
                  JSON.parse(gps ?? "{}")?.Longitude
                : convertValue(
                    band_diameter,
                    parsedData?.units?.["Band Diameter"],
                    false,
                    getDecimalPoint(MEASUREMENT_KEYS.DISTANCE, globalUnit)
                  ),
            wireDiameter:
              type == "Lead" || station_number == "0"
                ? convertValue(
                    lead_wire_diameter,
                    parsedData?.units?.["Wire Diameter"],
                    false,
                    getDecimalPoint(MEASUREMENT_KEYS.WIRE_DIAMETER, globalUnit)
                  )
                : convertValue(
                    trail_wire_diameter,
                    parsedData?.units?.["Wire Diameter"],
                    false,
                    getDecimalPoint(MEASUREMENT_KEYS.WIRE_DIAMETER, globalUnit)
                  ),
            loggingDistance:
              station_number == "0"
                ? JSON.parse(iwm || "{}")?.Logging_period
                : convertValue(
                    logging_distance,
                    parsedData?.units?.["Logging Distance"],
                    false,
                    getDecimalPoint(MEASUREMENT_KEYS.DISTANCE, globalUnit)
                  ),
          },
        ]);
      } catch (e) {
        console.log(e);
      }
    }
  }, [projectReducer?.selectedProject?.reportColumns]);

  const loader = reducer?.isTlogsLoading;
  const [activeTab, setActiveTab] = useState("TableView");

  const [columns, setColumns] = useState([
    {
      title: t("tlogData.bugno"),
      dataIndex: "bugNumber",
      key: "bugNumber",
    },
    {
      title: `${
        selectedProject.weldAssignmentType == "GPS"
          ? t("tlogData.gps")
          : t("tlogData.bandDiameter") +
            `( ${tlogHelper.returnUnitBasedOnColumns(
              reportColumnEnums.BandDiameter,
              reportColumns
            )} )`
      }`,
      dataIndex: "gps",
      key: "gps",
    },
    {
      title:
        t("tlogData.wirediameter") +
        `( ${tlogHelper.returnUnitBasedOnColumns(
          reportColumnEnums.WireDiameter,
          reportColumns
        )} )`,
      dataIndex: "wireDiameter",
      key: "wireDiameter",
    },
    {
      title:
        t("tlogData.loggingdistance") +
        `( ${tlogHelper.returnUnitBasedOnColumns(
          reportColumnEnums.LoggingDistance,
          reportColumns
        )} )`,
      dataIndex: "loggingDistance",
      key: "loggingDistance",
    },
    {
      title: t("tlogData.pipediameter"),
      dataIndex: "pipeDiameter",
      key: "pipeDiameter",
    },
    {
      title: t("tlogData.autoIncrement"),
      dataIndex: "autoIncrement",
      key: "autoIncrement",
    },
    {
      title: t("tlogData.weldstarttime"),
      dataIndex: "weldStartTime",
      key: "weldStartTime",
    },
    {
      title: t("tlogData.Weldendtime"),
      dataIndex: "weldEndTime",
      key: "weldEndTime",
    },
    {
      title: t("tlogData.weldtime"),
      dataIndex: "weldTime",
      key: "weldTime",
    },
  ]);

  const [data, setDataParams] = useState(
    loader
      ? [
          {
            key: 1,
            bugNumber: "--",
            gps: "--",
            wireDiameter: "--",
            loggingDistance: "--",
            pipeDiameter: "--",
            jobNumber: "--",
            autoIncrement: "--",
            weldStartTime: "--",
            weldEndTime: "--",
            weldTime: "--",
          },
        ]
      : [
          {
            key: 1,
            bugNumber: bug_number,
            gps:
              selectedProject.weldAssignmentType == "GPS"
                ? JSON.parse(gps ?? "{}")?.Latitude +
                  ", " +
                  JSON.parse(gps ?? "{}")?.Longitude
                : band_diameter,
            wireDiameter:
              type == "Lead" || station_number == "0"
                ? convertValue(
                    lead_wire_diameter,
                    reportColumns?.units?.["Wire Diameter"],
                    false,
                    getDecimalPoint(MEASUREMENT_KEYS.WIRE_DIAMETER, globalUnit)
                  )
                : convertValue(
                    trail_wire_diameter,
                    reportColumns?.units?.["Wire Diameter"],
                    false,
                    getDecimalPoint(MEASUREMENT_KEYS.WIRE_DIAMETER, globalUnit)
                  ),
            loggingDistance:
              station_number == "0"
                ? JSON.parse(iwm || "{}")?.Logging_period
                : convertValue(
                    logging_distance,
                    reportColumns?.units?.["Logging Distance"],
                    false,
                    getDecimalPoint(MEASUREMENT_KEYS.DISTANCE, globalUnit)
                  ),
            pipeDiameter: pipe_diameter,
            autoIncrement: autoIncrement,
            weldStartTime: logDataHelperFunctions.formatWeldStartTime(
              start_time,
              false,
              false,
              true
            ),
            weldEndTime: logDataHelperFunctions.formatWeldStartTime(
              end_time,
              false,
              false,
              true
            ),
            weldTime: weld_time,
          },
        ]
  );

  const PqrreportLink = useSelector(
    (state) => state.pqrdataReducer?.pqrReportLinkData?.recordList
  );

  const excludedTlogsValues = useMemo(() => {
    const excludedTlogsKey = PqrreportLink?.[0]?.excluded_tlogs_key || "{}";

    let excludedTlogsData = [];

    try {
      excludedTlogsData = excludedTlogsKey
        ? JSON.parse(excludedTlogsKey)?.excluded_tlogs_key
        : [];
    } catch (error) {
      console.error("Failed to parse excludedTlogsKey:", error);
      excludedTlogsData = [];
    }

    return (
      excludedTlogsData?.find(
        (ite) =>
          ite.pass_name == passn &&
          ite.torch == Bugtype &&
          ite.weld_number == weld_no &&
          ite?.s_deviceid_event == s_deviceid_event
      )?.excluded_tlogs || []
    );
  }, [PqrreportLink]);

  const [selectedRowKeys, setSelectedRowKeys] = useState(excludedTlogsValues);

  useEffect(() => {
    console.log("inside use effect --- ", excludedTlogsValues);
    setSelectedRowKeys(excludedTlogsValues);
  }, [excludedTlogsValues]);

  const [isGenerating, setIsGenerating] = useState(false);

  const handleAssignButtonClick = () => {
    setIsGenerating(true);
    const excludedTlogsArray = [
      {
        pass_name: passn || "",
        torch: Bugtype || "",
        weld_number: weld_no || "",
        excluded_tlogs: selectedRowKeys || "",
        s_deviceid_event: s_deviceid_event || "",
      },
    ];
    const payload = {
      project_id: selectedProjectId,
      project_name: selectedProjectName,
      excluded_tlogs: excludedTlogsArray,
      weld_numbers: weldNumber,
      boundary: boundary,
    };

    dispatch({
      type: POST_EXCLUDED_SAGA,
      payload,
      cb: () => {
        setIsGenerating(false);
        // history.push(`/pqr-table-data/${weldNumber}?boundary=${boundary}`);
        history.push({
          pathname: `/pqr-table-data/${weldNumber}`,
          search: `?boundary=${boundary}`,
          state: { isGenerating: true },
        });
        dispatch({ type: CHECKED_TLOG_DATA, payload: excludedTlogsArray });
      },
    });
  };

  let checkedexcludedTlogsArray = [];

  try {
    const excludedTlogsKeyObject = JSON.parse(
      PqrreportLink?.[0]?.excluded_tlogs_key || "{}"
    );

    const { pass_name, torch, weld_number, excluded_tlogs } =
      excludedTlogsKeyObject.excluded_tlogs_key?.[0] || {};

    checkedexcludedTlogsArray =
      pass_name || torch || weld_number || excluded_tlogs
        ? [{ pass_name, torch, weld_number, excluded_tlogs }]
        : [];
  } catch (error) {
    console.error("Error parsing excluded_tlogs_key:", error);
  }

  return (
    <div>
      <div className="slogweld-title">
        {!hasData ? (
          <>
            <Link to={"/data360-home"}>
              <div className="back_equip">
                <Tooltip title={"Back"}>
                  <ArrowLeftOutlined />
                </Tooltip>
                <h2 className="slogweld-header-active">Log Data</h2>
              </div>
            </Link>
            <Link to={`/slog-weld/${weld_number}`}>
              <div className="back_equip">
                <Tooltip title={"Back"}>
                  <ArrowLeftOutlined />
                </Tooltip>
                <h2 className="slogweld-header-active">Weld {weld_number}</h2>
              </div>
            </Link>
            <div className="back_equip-unActive">
              <ArrowLeftOutlined />
              <h2 className="slogweld-header">
                {stationNumbers} : {buyType}
                {type ? ` | ${type}` : ""}
                {zone ? ` : ${zone}` : ""}
              </h2>
            </div>
          </>
        ) : (
          <>
            <Link to={"/data360-home/pqr-report"}>
              <div className="back_equip">
                <Tooltip title={"Back"}>
                  <ArrowLeftOutlined />
                </Tooltip>
                <h2 className="slogweld-header-active">PQR Report</h2>
              </div>
            </Link>
            <Link
              to={{
                pathname: `/pqr-table-data/${weldNumber}`,
                search: `?boundary=${boundary}`,
                state: { checkedexcludedTlogsArray },
              }}
            >
              <div className="back_equip">
                <Tooltip title={"Back"}>
                  <ArrowLeftOutlined />
                </Tooltip>
                <h2 className="slogweld-header-active">Weld {weldNumber}</h2>
              </div>
            </Link>
            <Link
              to={{
                pathname: `/wps-limit-table`,
                search: `?boundary=${boundary}`,
                state: { passname: passn, weld_number: weldNumber },
              }}
            >
              <div className="back_equip">
                <Tooltip title={"Back"}>
                  <ArrowLeftOutlined />
                </Tooltip>
                <h2 className="slogweld-header-active">{passn}</h2>
              </div>
            </Link>
            <div className="back_equip-unActive">
              <ArrowLeftOutlined className="arrowSpace" />
              <h2 className="slogweld-header-last">
                {weld_no} : {Bugtype == "iwm" ? "" : Bugtype + " : "}{" "}
                {bugTypepqr}
              </h2>
            </div>
          </>
        )}
        <div className="tlognavigatebtn">
          {hasData && (
            <Button
              type="primary"
              className={selectedRowKeys?.length > 0 ? "assign" : "disable"}
              onClick={handleAssignButtonClick}
              disabled={!selectedRowKeys?.length || isGenerating}
            >
              Generate
            </Button>
          )}
          {activeTab === "TableView" && boundary ? <></> : ""}
        </div>
      </div>
      <>
        {!hasData ? (
          <div className="tlog-detail-bar">
            <Table
              columns={columns
                ?.filter((ite) => {
                  if (
                    station_number == "0" &&
                    ite.dataIndex == "loggingDistance"
                  ) {
                    ite.title = "Logging Period (sec)";
                  }
                  return selectedProject?.weldAssignmentType == "GPS" &&
                    ite.dataIndex == "gps"
                    ? ite
                    : station_number == "0" && ite.dataIndex == "gps"
                    ? null
                    : ite;
                })
                .filter((ite) => ite != null)}
              dataSource={data}
              pagination={false}
            />
          </div>
        ) : null}
      </>
      {!hasData ? (
        <TlogTab
          weld_number={weld_number}
          zone={zone}
          type={type}
          s_deviceid_event={s_deviceid_event}
          station_number={station_number}
          setActiveTab={setActiveTab}
          tilt_start={tilt_start}
          tilt_end={tilt_end}
          isM500={isM500}
          rawZoneView={rawZoneView}
          view={view}
        />
      ) : (
        <TlogTableView
          weld_number={weld_number}
          type={type}
          zone={zone}
          s_deviceid_event={s_deviceid_event}
          station_number={station_number}
          boundary={boundary}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          tilt_start={tilt_start}
          tilt_end={tilt_end}
          isM500={isM500}
          rawZoneView={rawZoneView}
          view={view}
        />
      )}
    </div>
  );
};

export default TlogData;
